module.exports = __webpack_public_path__ + "static/dbamy-o-kazdy-d8a34977102cc22d9ed0da8dd0d7129d.jpg";